import React from 'react';
import {defineMessages} from 'react-intl';
import {StyledAccordion} from '@igp/shared/components/accordion';
import {PlayerFinancialSummary} from '@igp/shared/features/shared-blocks';
import {EntityType} from '@models';

import {PlayerTransactionHistory} from './PlayerTransactionHistory';

const localized = defineMessages({
    title: {
        id: 'PlayerFinancialInfo_title',
        defaultMessage: 'Financial Info',
    },
});

type PlayerFinancialInfoProps = {
    uid: string;
};

export function PlayerFinancialInfo({uid}: PlayerFinancialInfoProps) {
    return (
        <StyledAccordion
            header={localized.title}
            componentId={'PlayerFinancialInfo'}
            isCollapsed
            unmountOnCollapse
            children={
                <>
                    <PlayerFinancialSummary<EntityType>
                        userId={uid}
                        currency={'USD'}
                        transactionEntity={EntityType.Transaction}
                        userActivitySummaryEntity={EntityType.UserActivitySummary}
                        cells={[
                            'depositTotal',
                            'withdrawalTotal',
                            'lastDeposit',
                            'netDeposits',
                            'balance',
                            'withdrawableBalance',
                            'p2pCreditTotal',
                            'p2pDebitTotal',
                            'status',
                            'daysSinceLastActive',
                            'daysSinceRegistration',
                            'lastGame',
                            'favCasinoGames',
                            'favSlotGames',
                            'favPokerGames',
                            'averageBet',
                            'averagePokerBuyIn',
                            'lifetimeGGR',
                            'casinoGGR',
                            'pokerGGR',
                            'sportsGGR',
                            'casinoCoinBalance',
                            'vip',
                            'bonusTotal',
                            'bonusRatio',
                            'bonusToDeposit',
                            'eligibleForBonus',
                            'max',
                            'lastBonus',
                        ]}
                    />
                    <PlayerTransactionHistory uid={uid} />
                </>
            }
        />
    );
}
